// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ab2fb00f","453":"89c451ea","732":"fea1bc40"}[chunkId] + ".chunk.js";
};